import { Col } from 'reactstrap';
import PropTypes from 'prop-types';

const Component = ({ children, hidden, ...props }) => {
  if (hidden) return null;
  return <Col {...props}>{children}</Col>;
};

Component.propTypes = {
  hidden: PropTypes.bool,
  xs: PropTypes.any,
  sm: PropTypes.any,
  md: PropTypes.any,
  lg: PropTypes.any,
  xl: PropTypes.any,
  widths: PropTypes.arrayOf(PropTypes.string),
};

export default Component;
